export const styles = theme => ({
  tableRow: {
    height: 46
  },
  tableCell: {
    paddingLeft: theme.spacing.unit,
    paddingRight: theme.spacing.unit
  }
})


// WEBPACK FOOTER //
// ./src/components/BigCalendar/components/BigCalendarHead/styles.js